;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$timeout", "$window", "$document", "surveyReport", "reportQuestionExporter", "reportModService", "Question", "glAnalytics", "responseTypeService", "uacService", "reportMediaBtn", "glToast"];
  angular.module('glow.reporting').component('reportViewQuestion', {
    controller: Controller,
    templateUrl: 'report-view-question.html',
    bindings: {
      survey: '<',
      question: '<',
      filterSetGroup: '<',
      loopTracker: '<',
    },
  })

  /* @ngInject */
  function Controller(
    $scope,
    $timeout,
    $window,
    $document,
    surveyReport,
    reportQuestionExporter,
    reportModService,
    Question,
    glAnalytics,
    responseTypeService,
    uacService,
    reportMediaBtn,
    glToast
  ) {
    var ctrl = this

    ctrl.chartIcons = {
      heatmap: 'public',
      pointmap: 'location',
      gauge: 'gauge',
      pie: 'pie-chart',
      bar: 'bar-chart',
      cloud: 'cloud',
      rating: 'bar-chart',
      // radar: 'radar',
      stacked: 'stacked-chart',
      matrixbar: 'bar-chart',
      gallery: 'gallery',
    }
    ctrl.chartPercentSupported = {
      bar: true,
      pie: true,
      stacked: true,
      matrixbar: true,
    }
    ctrl.mediaBtnType = reportMediaBtn.Types.IMAGE

    ctrl.$onChanges = onChanges
    ctrl.$onDestroy = onDestroy
    ctrl.getSelectedLoopKeyId = getSelectedLoopKeyId
    ctrl.hasValidLoopConfig = hasValidLoopConfig
    ctrl.exportDownload = exportDownload
    ctrl.onTableSort = onTableSort
    ctrl.toMarkdown = toMarkdown
    ctrl.canTogglePercentage = canTogglePercentage
    ctrl.togglePercentage = togglePercentage
    ctrl.canRotateChart = canRotateChart
    ctrl.canEditTheme = canEditTheme
    ctrl.editTheme = editTheme
    ctrl.canEditMods = canEditMods
    ctrl.editMods = editMods
    ctrl.shouldShowNewChart = shouldShowNewChart

    $scope.$on('survey-reporting:load-start', function() {
      ctrl.loading = true
    })
    $scope.$on('survey-reporting:load-end', function() {
      ctrl.loading = false
    })

    function init() {
      $window.addEventListener('resize', updateHeights)
      updateHeights()
      ctrl.hasInit = true
    }

    function onChanges(changes) {
      if (!ctrl.hasInit) init()
      if (changes.survey) {
        // ...
      }
      if (changes.question) {
        if (ctrl.question.type === 'score' && ctrl.question.isMatrix) {
          // score doesn't show "All Statements" option on statement switcher
          // so we pre-select the subType with first statement
          ctrl.subtype = ctrl.question.statements[0].id
        } else {
          ctrl.subtype = null
        }
      }
      ctrl.remounting = true
      ctrl.sortConfig = null
      ctrl.chartConfig = _.find(surveyReport.chartConfigs, function(config) {
        var isType = config.questionType === ctrl.question.type
        var hasSameMulti = _.isBoolean(config.isMulti)
          ? config.isMulti === ctrl.question.isMulti
          : true
        var hasSameMatrix = _.isBoolean(config.isMatrix)
          ? config.isMatrix === ctrl.question.isMatrix
          : true
        return isType && hasSameMulti && hasSameMatrix
      })
      ctrl.chartType = ctrl.chartConfig.default
      ctrl.isPercentage = _.defaultTo(ctrl.isPercentage, true)
      ctrl.canExport = reportQuestionExporter.canExport(ctrl.question.type)
      ctrl.isDataTable = !_.includes(
        ['singletext', 'text', 'scan', 'location', 'image'],
        ctrl.question.type
      )
      ctrl.isAnswersTable = _.includes(
        ['singletext', 'text', 'scan'],
        ctrl.question.type
      )
      ctrl.isOtherAnswersTable = ctrl.question.hasOtherAnswers

      if (ctrl.isDataTable) {
        ctrl.table = 'data'
      } else if (ctrl.isAnswersTable) {
        ctrl.table = 'answers'
      } else if (ctrl.isOtherAnswersTable) {
        ctrl.table = 'other'
      } else {
        ctrl.table = null
      }

      // force all child components to remount. some child components
      // (chart colors, tables etc) aren't responding correctly to
      // prop changes when flipping between questions and i don't
      // have time to investigate further
      // - ash
      $timeout(function() {
        ctrl.remounting = false
      }, 5)
    }

    function onDestroy() {
      $window.removeEventListener('resize', updateHeights)
    }

    function updateHeights() {
      $scope.$applyAsync(function() {
        // var chartHeight =
        //   $window.innerWidth < 415 ? 300 : $window.innerHeight - 340
        // limit the chart height to maximum 500px
        // ctrl.chartHeight = chartHeight > 500 ? 500 : chartHeight
        ctrl.chartHeight = 380 // matches question-chart
        // ctrl.tableMaxHeight =
        //   $window.innerWidth < 900 ? null : $window.innerHeight - 450
        ctrl.shouldShowAllMatrixBarChart = $window.innerWidth > 900
      })
    }

    function getSelectedLoopKeyId() {
      return ctrl.question.loop
        ? ctrl.loopTracker.getSelected(ctrl.question.loop.id)
        : null
    }

    function exportDownload() {
      reportQuestionExporter
        .toData(
          ctrl.survey,
          ctrl.question,
          ctrl.filterSetGroup.getSelected(),
          ctrl.filterSetGroup.getOperator(),
          responseTypeService.getSelected(),
          getSelectedLoopKeyId()
        )
        .then(function(data) {
          data.download()
        })
        .catch(function(error) {
          glToast.show('Failed to Download as CSV. Message: ' + error.message)
        })
      glAnalytics.track('ReportQuestionExport', 'download', ctrl.question.id)
    }

    function onTableSort(sortConfig) {
      ctrl.sortConfig = sortConfig
    }

    function hasValidLoopConfig() {
      if (!ctrl.question.loop) return true
      return ctrl.loopTracker.has(ctrl.question.loop.id)
    }

    function toMarkdown(string) {
      return window.marked(string)
    }

    function canTogglePercentage() {
      return ['bar', 'pie', 'doughnut'].includes(ctrl.chartType)
    }

    function togglePercentage() {
      ctrl.isPercentage = !ctrl.isPercentage
    }

    function canRotateChart() {
      return ['bar', 'rating', 'matrixbar'].includes(ctrl.chartType)
    }

    var newChartTypes = ['bar', 'pie', 'doughnut', 'radar']
    function shouldShowNewChart() {
      return newChartTypes.includes(ctrl.chartType)
    }

    function canEditTheme() {
      return (
        ctrl.survey.options.showReportSettingsButton &&
        !_.includes(['cloud', 'gallery', 'pointmap', 'heatmap'], ctrl.chartType)
      )
    }

    function editTheme() {
      if (!ctrl.survey.options.canEditReportSettings) {
        return uacService.showAlertDialog('edit chart theme')
      }
      $scope.$emit('edit-question-theme', ctrl.question)
    }

    function canEditMods() {
      return (
        ctrl.survey.options.showReportSettingsButton &&
        _.includes(
          [Question.Types.CHOICE, Question.Types.SCALE, Question.Types.MATRIX],
          ctrl.question.type
        )
      )
    }

    function editMods() {
      reportModService
        .showDialog(ctrl.survey, ctrl.question.id)
        .then(function() {
          $scope.$emit('mods:changed')
        })
    }
  }
})()
